import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { connect } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import S3Uploader from '../s3Uploader/s3Uploader';
import * as logger from '../../../logger';
import { addDocumentDialogCss as useStyles } from './VehicleDialogCss';
import { getTripDateFilterValues, numberWithCommas, replaceCommas, checkNumberOnly, numberWithCommasInput } from '../../../utils/utils';
import { addDocument, deletePhotoDocuments, editDocument } from '../../../store/actions/vehicleActionCreator';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import Alert from '@material-ui/lab/Alert';
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';


const AddDocumentDialog = ({ open, onClose, callRecall, user, renew, docIdValue, otherDocumentFlagValue, vehicle, individualDocument, dispatchEditDocument, expenseId, onConfirm, dispatchAddDocument, edit, dispatchDeleteDocumentsPhoto }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [addExpensePhoto, setAddExpensePhoto] = useState([]);
    const [checkButton, setCheckButton] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [amountValue, setAmountValue] = useState("");
    const [documentValue, setDocumentValue] = useState("");

    const classes = useStyles();

    let documentBookDetails = vehicle && vehicle.documentsBooks ? vehicle.documentsBooks : {}
    let singleTruckData = vehicle && vehicle.singleTruck ? vehicle.singleTruck : {}

    const initialValues = {
        expiryDate: edit && individualDocument.expiryDate ? new Date(individualDocument.expiryDate * 1000) : "",
        documentNumberFieldName: edit && individualDocument.documentId ? individualDocument.documentId : "",
        expenseDate: edit && individualDocument.expenseDate ? new Date(individualDocument.expenseDate * 1000) : new Date(),
        amount: amountValue ? amountValue : edit && individualDocument.amount ? numberWithCommas(individualDocument.amount) : "",
        reminderValue: edit && individualDocument && individualDocument.reminderDuration ? individualDocument.reminderDuration + " " + (individualDocument.reminderDuration == 1 ? "day" : individualDocument.reminderDurationUnit) : individualDocument && individualDocument.config && individualDocument.config.defaultExpiryReminderDuration && individualDocument.config.defaultExpiryReminderDurationUnit ? individualDocument.config.defaultExpiryReminderDuration + " " + (individualDocument.config.defaultExpiryReminderDuration == "1" ? "day" : individualDocument.config.defaultExpiryReminderDurationUnit) : "",
        documentNameValue: documentValue ? documentValue : individualDocument.documentName
    };

    useEffect(() => {
        if (edit) {
            if (individualDocument.amount) {
                setCheckButton(true)
            }
            if (individualDocument.attachments) {
                setAddExpensePhoto(individualDocument.attachments);
            }
        }
    }, [open]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleAddExpensePhoto = (file) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.push({ s3Link: file });
        setAddExpensePhoto(newPhoto);
    }

    const handleDeleteExpensePhoto = (index, attachId) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.splice(index, 1);
        setAddExpensePhoto(newPhoto);

        if (attachId) {
            dispatchDeleteDocumentsPhoto(
                individualDocument.id,
                attachId,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Add Document Dialog Dweb", "Attachment deleted successfully");
                        callRecall();
                    }
                },
                () => {
                    logger.log("Add Document Dialog Dweb", "Attachment delete failed");
                },
            )
        }
    }

    const handleAddButton = () => {
        setCheckButton(true);
    }

    const validate = values => {

        const errors = {}

        let documentNameTest = values.documentNameValue ? /^[A-Za-z]+$/.test(values.documentNameValue.replace(/\s+/g, '')) : "";

        if (values.amount || values.expiryDate || values.documentNumberFieldName || addExpensePhoto && addExpensePhoto.length > 0) {
            setErrorFlag(false);
        }

        if (otherDocumentFlagValue && !documentNameTest) {
            errors.documentNameValue = "Please enter valid document name."
        }

        if (checkButton && values.amount && !checkNumberOnly(replaceCommas(values.amount))) {
            errors.amount = "Please enter valid amount."
        }

        return errors;

    }

    const validateConfirm = (values) => {
        if (values.expiryDate || values.documentNumberFieldName || values.amount || addExpensePhoto && addExpensePhoto.length > 0) {
            return false
        }
        else {
            return true
        }
    }

    const onSubmit = values => {

        if (validateConfirm(values)) {
            setErrorFlag(true);
            return;
        }

        let attach = [];
        addExpensePhoto.map((link) => {
            if (typeof (link) === 'object') {
                attach.push({ s3Link: link.s3Link, id: link.id });
            } else {
                attach.push({ s3Link: link });
            }
        })

        let reminderValue = {};

        if (values && values.reminderValue && documentBookDetails && documentBookDetails.reminder_config) {
            let reminderIndex = documentBookDetails.reminder_config.findIndex(x => x.display === values.reminderValue);
            reminderValue = documentBookDetails.reminder_config[reminderIndex];
        }

        let data = {
            vehicleId: singleTruckData && singleTruckData.id ? Number(singleTruckData.id) : "",
            documents: {
                documentEntityType: individualDocument && individualDocument.documentEntityType ? individualDocument.documentEntityType : "",
                // documentId: values.documentNumberFieldName.toUpperCase(),
                documentType: otherDocumentFlagValue && values && values.documentNameValue ? values.documentNameValue : individualDocument && individualDocument.documentType ? individualDocument.documentType : "",
                documentName: otherDocumentFlagValue && values && values.documentNameValue ? values.documentNameValue : individualDocument && individualDocument.config && individualDocument.config.name ? individualDocument.config.name : "",
                expiryDate: values.expiryDate ? Math.round((values.expiryDate.setHours(0, 0, 0, 0) / 1000)) : null,
                // expenseDate: Math.round((selectedDate.getTime() / 1000)),
                // amount: expenseAmount,
                fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
                isReminderEnabled: values && values.expiryDate ? 1 : 0,
                reminderDuration: reminderValue && reminderValue.value && reminderValue.value.count ? Number(reminderValue.value.count) : "",
                reminderDurationUnit: reminderValue && reminderValue.value && reminderValue.value.unit ? reminderValue.value.unit : "",
                attachments: attach
            }
        }

        if (values && values.documentNumberFieldName) {
            data.documents.documentId = values.documentNumberFieldName.toUpperCase();
        }

        // if (values && values.expiryDate) {
        //     data.documents.expiryDate = Math.round((values.expiryDate.setHours(0, 0, 0, 0) / 1000));
        // }

        if (checkButton) {
            if (values && values.expenseDate) {
                data.documents.expenseDate = Math.round((values.expenseDate.setHours(0, 0, 0, 0) / 1000));
            }
            if (values && values.amount) {
                data.documents.amount = replaceCommas(values.amount);
            }
        }

        //for editting document.
        if (edit) {
            data.documents.id = individualDocument.id ? individualDocument.id : "";
        }

        //For renewing document.
        if (renew && docIdValue) {
            data.existingDocumentId = docIdValue;
        }

        if (edit) {

            dispatchEditDocument(data,
                (data) => {
                    logger.log("Document Book", "data", data)
                    if (data && data.status.code && data.status.code == 200) {
                        if (renew) {
                            trackDwebEvent("", {
                                vehicle_id: data && data.response && data.response.vehicleId ? data.response.vehicleId : "",
                                vehicle_number: data && data.response && data.response.vehicleNumber ? data.response.vehicleNumber : "",
                                document_type: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].documentType ? data.response.documents[0].documentType : "",
                                document_number: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].documentId ? data.response.documents[0].documentId : "",
                                document_expiry: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].expiryDate ? new Date(data.response.documents[0].expiryDate * 1000) : "",
                                count_of_images_uploaded: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].attachments && data.response.documents[0].attachments.length > 0 ? data.response.documents[0].attachments.length : 0,
                                document_id: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].id ? data.response.documents[0].id : "",
                            });
                        } else {
                            trackDwebEvent("Dweb SVP Document Updated Successfully", {
                                vehicle_id: data && data.response && data.response.vehicleId ? data.response.vehicleId : "",
                                vehicle_number: data && data.response && data.response.vehicleNumber ? data.response.vehicleNumber : "",
                                document_type: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].documentType ? data.response.documents[0].documentType : "",
                                document_number: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].documentId ? data.response.documents[0].documentId : "",
                                document_expiry: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].expiryDate ? new Date(data.response.documents[0].expiryDate * 1000) : "",
                                count_of_images_uploaded: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].attachments && data.response.documents[0].attachments.length > 0 ? data.response.documents[0].attachments.length : 0,
                                document_id: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].id ? data.response.documents[0].id : "",
                            });
                        }
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Document Book", "Failed");
                }
            );

        } else {
            dispatchAddDocument(data,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        logger.log("Document Book Dweb", "Add document successfull");
                        if (otherDocumentFlagValue) {
                            trackDwebEvent("Dweb SVP Document Created Successfully", {
                                vehicle_id: data && data.response && data.response.vehicleId ? data.response.vehicleId : "",
                                vehicle_number: data && data.response && data.response.vehicleNumber ? data.response.vehicleNumber : "",
                                document_type: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].documentType ? data.response.documents[0].documentType : "",
                                document_number: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].documentId ? data.response.documents[0].documentId : "",
                                document_expiry: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].expiryDate ? new Date(data.response.documents[0].expiryDate * 1000) : "",
                                count_of_images_uploaded: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].attachments && data.response.documents[0].attachments.length > 0 ? data.response.documents[0].attachments.length : 0,
                                document_id: data && data.response && data.response.documents && data.response.documents[0] && data.response.documents[0].id ? data.response.documents[0].id : "",
                            });
                        }
                        setDialogOpen(false);
                        onConfirm();
                    } else {
                        if (otherDocumentFlagValue) {
                            trackDwebEvent("Dweb SVP Document Created Failed", {
                                vehicle_id: singleTruckData && singleTruckData.id ? singleTruckData.id : "",
                                vehicle_number: singleTruckData && singleTruckData.vehicleNumber ? singleTruckData.vehicleNumber : "",
                                document_type: otherDocumentFlagValue && values && values.documentNameValue ? values.documentNameValue : "",
                                document_number: values && values.documentNumberFieldName && values.documentNumberFieldName.toUpperCase() ? values.documentNumberFieldName.toUpperCase() : "",
                                document_expiry: values && values.expiryDate ? Math.round((values.expiryDate.setHours(0, 0, 0, 0) / 1000)) : null,
                                count_of_images_uploaded: attach && attach.length > 0 ? attach.length : 0,
                                error_reason: data && data.status && data.status.message ? data.status.message : ""
                            })
                        }

                    }
                },
                () => {
                    logger.log("Document Book Dweb", "Add document failed");
                }
            );
        }

    }

    const handleDocumentName = (name) => {

        if (/^\s+$/.test(name)) {
            setDocumentValue('');
        } else {
            setDocumentValue(name);
        }

    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: otherDocumentFlagValue,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Document Name</div>
                            <TextField
                                placeholder="Document Name"
                                name="documentNameValue"
                                onChange={(e) => handleDocumentName(e.target.value)}
                                variant="outlined"
                                size="small"
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>{renew ? "New Expiry Date" : "Expiry Date"}</div>
                            <DatePicker
                                name="expiryDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                // onChange={(date) => { setTripStartDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Expiry Date"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.marginV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            />
                            <div className={classes.formHelperText}>Optional</div>
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: values.expiryDate,
                field: (
                    <div className={classes.divV8}>
                        <AddAlertIcon />
                        <div>Remind me</div>
                        {documentBookDetails && documentBookDetails.reminder_config && documentBookDetails.reminder_config.length > 0 &&
                            <Select
                                name="reminderValue"
                                variant="outlined"
                                //label={''}
                                notched
                                labelwidth={0}
                                placeholder={''}
                                formControlProps={{ margin: 'none', size: "small", fullWidth: false, labelwidth: 0 }}
                                className={classes.selectV1}
                            >
                                {documentBookDetails && documentBookDetails.reminder_config && documentBookDetails.reminder_config.length > 0 && documentBookDetails.reminder_config.map((type, index) => {
                                    return (<MenuItem key={index} value={type.display}>{type.display}</MenuItem>);
                                })}
                            </Select>
                        }
                        <div className={classes.divV9}>before expiry</div>
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>{individualDocument && individualDocument.config && individualDocument.config.documentNumberFieldName ? individualDocument.config.documentNumberFieldName : ""}</div>
                            <TextField
                                placeholder={"Enter " + (individualDocument && individualDocument.config && individualDocument.config.documentNumberFieldName ? individualDocument.config.documentNumberFieldName : "")}
                                name="documentNumberFieldName"
                                variant="outlined"
                                size="small"
                                className={classes.documentNumber}
                            />
                            <div className={classes.formHelperText}>Optional</div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            {addExpensePhoto && addExpensePhoto.length > 0 &&
                                <Grid item>
                                    <div className="S3Uploader-image-margin">
                                        {addExpensePhoto && addExpensePhoto.map((expenseImage, index) => (
                                            <div className="S3Uploader-image-div" key={index}>
                                                {expenseImage.s3Link && <img className="S3Uploader-imagesrc" src={expenseImage.s3Link} alt="fileUpload" />}
                                                <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => { handleDeleteExpensePhoto(index, expenseImage.id) }}></img>
                                            </div>
                                        ))}
                                    </div>
                                </Grid>}
                            <Grid item>
                                <S3Uploader toggle={true} directoryName={"dweb-images/Vehicle/AddDocument"} handleFile={handleAddExpensePhoto} />
                            </Grid>
                        </Grid>
                    </div>
                ),
            },
            {
                size: 12,
                visible: !checkButton,
                field: (
                    <div>
                        <Button variant="outlined" onClick={() => handleAddButton()} className={classes.checkButton}>
                            {"Add" + " " + (individualDocument && individualDocument.config && individualDocument.config.name ? individualDocument.config.name : "") + " " + "Expense"}
                        </Button>
                    </div>
                )
            },
            {
                size: 12,
                visible: checkButton,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Expense Amount</div>
                            <AmountInput
                                placeholder="Expense Amount"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => { setAmountValue(e.target.value) }}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                            <div className={classes.formHelperText}>Optional</div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: checkButton,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Expense Date</div>
                            <DatePicker
                                disableFuture
                                name="expenseDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                // onChange={(date) => { setTripStartDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Select Date"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.marginV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            />
                        </div>
                    </>
                ),
            }
        ]
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='sm'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>{individualDocument && individualDocument.config && individualDocument.config.name ? (edit || renew ? (edit ? "Edit" : "Renew") : "Add") + " " + individualDocument.config.name : ""}</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <div className={classes.divBox}>
                        <div className={classes.color1}>
                            Truck Info.
                        </div>
                        <span className={classes.divData}>
                            {documentBookDetails && documentBookDetails.vehicleNumberDweb && documentBookDetails.vehicleNumberDweb.map((number, index) => (
                                <span className={classes.vehicleNumber} key={index}>{number}</span>
                            )
                            )}
                        </span>
                        <span className={classes.bullet}>•</span>
                        <span className={classes.divData}>{documentBookDetails.vehicleBodyType}</span>
                    </div>

                    {errorFlag &&
                        <Alert severity="error" className={classes.marginV2}>Please enter document details.</Alert>
                    }

                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle, user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchEditDocument: (data, onSuccess, onFailure) => dispatch(editDocument(data, onSuccess, onFailure)),
    dispatchAddDocument: (data, onSuccess, onFailure) => dispatch(addDocument(data, onSuccess, onFailure)),
    dispatchDeleteDocumentsPhoto: (documentId, attachId, onSuccess, onFailure) => dispatch(deletePhotoDocuments(documentId, attachId, onSuccess, onFailure)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDocumentDialog);